import { IHierarchyNode, IHierarchyService } from "../../../hierarchy/common/hierarchy.js";
import { ILogService } from "../../../log/common/log.js";
import { IProjectService } from "../../../../editor/services/project/common/project.js";
import { AIContextProviderCapabilities, AITextContextChunk, IAIContextProvider } from "./../ai.js";


export class AIHierarchyContext implements IAIContextProvider {
    readonly capabilities: AIContextProviderCapabilities = AIContextProviderCapabilities.Text;

    constructor(
        @IHierarchyService private readonly hierarchy: IHierarchyService,
        @ILogService private readonly logger: ILogService,
    ) {
    }

    async getContext(): Promise<AITextContextChunk[] | null> {

        if (!this.hierarchy) {
            this.logger.warn("AIAppContext: No hierarchy available.");
            return null;
        }

        const hierarchy = this.hierarchy;

        let text = "";
        if (!hierarchy) {
            text += "Scene Hierarchy has no nodes.\n";
        }
        else {
            text += "Scene Hierarchy:\n";
            for (const node of hierarchy.roots) {
                const res = await this.serializeHierarchy({}, node, { nodes: 0, maxNodes: 2000 });
                text += JSON.stringify(res);
            }
        }

        return [{
            type: 'text',
            text: text,
        }]

    }


    private async serializeHierarchy(object: Record<string, object | string | number | boolean>, node: IHierarchyNode, context: { nodes: number, readonly maxNodes: number }, depth: number = 0): Promise<Record<string, object | string | number | boolean>> {


        if (context.nodes++ >= context.maxNodes) {
            object["system:warning"] = `<truncated>`;
            return object;
        }

        if(node.name?.length) object["name"] = node.name;
        if(node.label?.length) object["label"] = node.label;
        object["id"] = node.id;
        object["type"] = node.type;
        object["selected"] = node.selected;
        object["expanded"] = node.expanded;
        if (depth > 10) {
            object["system:warning"] = `Max depth reached, stopping serialization. The object has ${node.children.length} children not serialized.`;
            return object;
        }

        const children = object["children"] = new Array<object>();
        for (const child of node.children) {
            if (children.length > 100) {
                const skippedCount = node.children.length - children.length;
                object["system:warning"] = `Max children count reached, stopping serialization. Skipped ${skippedCount} children.`;
                break;
            }
            if (context.nodes >= context.maxNodes) {
                break;
            }
            const childObject = {};
            await this.serializeHierarchy(childObject, child, context, depth + 1);
            children.push(childObject);
        }


        return object;
    }
}
